export interface FaqItem {
  q: string
  paragraphs: string[]
  bullets?: string[]
  after?: string
}

export interface FaqGroup {
  id: string
  title: string
  items: FaqItem[]
}

export const faqGroups: FaqGroup[] = [
  {
    id: 'compra',
    title: 'Sobre la compra y el acceso',
    items: [
      {
        q: '¿Cómo funciona la compra? ¿Es segura?',
        paragraphs: [
          'La compra se procesa a través de Hotmart, una plataforma certificada con seguridad SSL 256-bit (el mismo nivel que usan los bancos). Después de completar el pago:',
        ],
        bullets: [
          'Recibirás un email de confirmación instantáneo',
          'Dentro del email estará tu enlace de acceso directo al producto',
          'Podrás descargar el PDF a tu computadora o tablet',
        ],
        after: 'No hay intermediarios ni demoras. Tienes acceso en menos de 1 minuto.',
      },
      {
        q: '¿Qué métodos de pago aceptan?',
        paragraphs: ['Hotmart acepta:'],
        bullets: [
          'Tarjetas de crédito y débito (Visa, Mastercard, American Express)',
          'Transferencia bancaria',
          'Billeteras digitales (según tu país)',
          'PayPal (en algunos países)',
        ],
        after:
          'La plataforma convierte automáticamente el precio a tu moneda local antes de que confirmes la compra. Verás el monto exacto en tu divisa antes de pagar.',
      },
      {
        q: '¿El precio de $15.90 es una promoción temporal?',
        paragraphs: [
          'Sí. Este es el precio de lanzamiento exclusivo. Después de hoy, el precio vuelve a $99 USD.',
          'Si accedes ahora, mantienes el acceso de por vida a ese precio. Si cierras esta página, tendrás que pagar el precio completo si lo compras después.',
        ],
      },
      {
        q: '¿Hay suscripción o cargos recurrentes?',
        paragraphs: [
          'No. Es un pago único de $15.90. Nunca te cobraremos de nuevo: no hay membresías ni renovaciones automáticas. Una vez que compras, es tuyo para siempre.',
        ],
      },
      {
        q: '¿Puedo compartir el PDF con mis amigas?',
        paragraphs: [
          'Técnicamente es posible, pero no te lo recomendamos (ni legalmente se permite). El contenido está protegido por derechos de autor.',
          'Lo que sí puedes hacer: compra tu copia y envíale el enlace a tu amiga para que compre la suya. A $15.90 es casi un regalo.',
        ],
      },
      {
        q: '¿Cómo funciona la garantía de 60 días?',
        paragraphs: ['Es muy simple:'],
        bullets: [
          'Compras hoy',
          'Aplicas el protocolo durante 60 días (no necesita ser perfecto, solo real)',
          'Si no ves resultados: tu cara sigue hinchada, tu abdomen no bajó, tu energía no mejoró',
          'Envías un email a nutrinaturalonline@gmail.com diciendo “Quiero mi dinero de vuelta”',
          'Recibes el 100% de tu dinero en 7 días hábiles',
        ],
        after:
          'Sin preguntas, sin formularios, sin negociación. La garantía es real porque conozco el protocolo y sé que funciona.',
      },
      {
        q: '¿Y si quiero devolver después de los 60 días?',
        paragraphs: [
          'Después de 60 días ya no aplica la garantía. Pero honestamente, a los 60 días ya habrás visto cambios: la mayoría los ve en los primeros 7-14 días.',
        ],
      },
      {
        q: '¿Dónde recibo el producto? ¿Por correo?',
        paragraphs: [
          'No, es digital: no es un producto físico. Recibirás un email con tu enlace de descarga directo. Descargarás un PDF que puedes:',
        ],
        bullets: [
          'Leer en tu computadora',
          'Descargar a tu tablet',
          'Imprimir si quieres',
          'Conservar para siempre',
        ],
        after: 'No requiere internet después de descargarlo.',
      },
      {
        q: '¿Puedo comprar desde mi país? ¿Funciona en todos lados?',
        paragraphs: [
          'Sí. Hotmart opera en más de 180 países y la moneda se convierte automáticamente a tu divisa local. Los países más comunes son:',
        ],
        bullets: [
          'Toda Latinoamérica (México, Colombia, Argentina, Chile, Perú, etc.)',
          'España',
          'Estados Unidos',
          'Portugal',
        ],
        after:
          'Si tienes dudas específicas sobre tu país, escribe a nutrinaturalonline@gmail.com.',
      },
      {
        q: '¿Hay derecho de autor sobre el contenido?',
        paragraphs: [
          'Sí. Todo el contenido del Código Cortisol está protegido por derechos de autor: no puedes distribuirlo públicamente, venderlo ni compartirlo en redes sin autorización. Compras el acceso personal para ti, no el derecho de revenderlo.',
        ],
      },
    ],
  },
  {
    id: 'protocolo',
    title: 'Sobre el protocolo',
    items: [
      {
        q: '¿Qué edad hay que tener para hacer este protocolo?',
        paragraphs: [
          'Está diseñado para mujeres de 30 años en adelante, pero cualquier mujer mayor de 18 con estrés crónico e inflamación puede beneficiarse. Si tienes menos de 18, consulta a tu médico primero (especialmente si aún estás en desarrollo hormonal).',
        ],
      },
      {
        q: '¿Puedo hacer el protocolo si estoy embarazada o amamantando?',
        paragraphs: [
          'No recomendamos aplicar cambios significativos durante el embarazo sin supervisión médica. Durante la lactancia, consulta primero con tu pediatra o ginecólogo, porque algunos cambios pueden afectar la composición de la leche.',
          'Lo que sí puedes hacer: leer el protocolo ahora, entenderlo y aplicarlo después de terminar la lactancia.',
        ],
      },
      {
        q: '¿Tengo que tomar suplementos caros?',
        paragraphs: [
          'No. El protocolo no requiere suplementos para funcionar. Lo que recomendamos es:',
        ],
        bullets: [
          'Magnesio glicinato (opcional, ~$15-20): mejora el sueño',
          'Sal celta o del Himalaya (muy barata, ~$5): para el suero adrenal',
        ],
        after:
          'El 90% del protocolo es luz solar, agua, comida real y hábitos de tiempo. La lista básica de suplementos opcionales está incluida en el Capítulo 4.',
      },
      {
        q: '¿Funciona si tengo tiroides lenta o problemas hormonales?',
        paragraphs: [
          'El protocolo está diseñado para normalizar el cortisol, que es una hormona. Si tienes hipotiroidismo, SOP u otros problemas hormonales, puede ayudarte, pero consulta a tu médico primero: no sustituye el tratamiento médico, lo complementa.',
          'Muchas mujeres con tiroides lenta han visto mejoras porque el cortisol alto interfiere con la función tiroidea.',
        ],
      },
      {
        q: '¿Funciona si tengo ansiedad o depresión?',
        paragraphs: [
          'Parcialmente. El protocolo baja el cortisol y muchas personas reportan menos ansiedad, mejor humor y mayor claridad mental.',
          'Pero si tienes depresión clínica o ansiedad severa, esto no sustituye terapia ni medicación. Úsalo como complemento junto a tu tratamiento profesional.',
        ],
      },
      {
        q: '¿Necesito ir al gimnasio o puedo hacer solo caminatas?',
        paragraphs: [
          'En los primeros 7 días, las caminatas son suficientes. De hecho, si estás en inflamación severa, el HIIT o el CrossFit pueden empeorarte: es mejor dar reposo a tu sistema nervioso.',
          'Después del día 7 puedes reintroducir entrenamiento de fuerza ligero, pero sin volver al cardio intenso si el cortisol vuelve a subir.',
        ],
      },
      {
        q: '¿Cuánto tiempo debo caminar después de comer?',
        paragraphs: ['15-20 minutos es el punto exacto. Este es el Protocolo 20-20:'],
        bullets: [
          'Después de comer, espera 1-2 minutos',
          'Camina lentamente durante 15-20 minutos',
          'Esto absorbe el azúcar de la sangre sin disparar el cortisol',
        ],
        after:
          'No necesita ser una caminata rápida. Incluso caminar alrededor de tu casa funciona.',
      },
      {
        q: '¿Tengo que desayunar temprano?',
        paragraphs: ['Idealmente sí, pero no es obligatorio. Lo importante es:'],
        bullets: [
          'Ver luz solar en los primeros 30 minutos de despertar (aunque esté nublado, cuenta)',
          'Comer proteína antes que café (a los 30 o 60 minutos, según tú)',
        ],
        after:
          'Si te despiertas a las 6 AM, lo ideal es desayunar entre 6:30 y 7 AM. Si despiertas a las 9 AM, entre 9:30 y 10 AM.',
      },
      {
        q: '¿Qué cantidad de proteína necesito en el desayuno?',
        paragraphs: ['Mínimo 20 gramos. Por ejemplo:'],
        bullets: [
          '3 huevos (18 g)',
          '1 taza de yogur griego (20 g)',
          '100 g de pechuga (30 g)',
          '2 cucharadas de mantequilla de maní (8 g) + tostada con queso',
        ],
        after: 'El objetivo es estabilizar la glucosa matinal para evitar el pico de cortisol.',
      },
      {
        q: '¿Puedo tomar café si respeto el protocolo de proteína primero?',
        paragraphs: ['Sí, pero con límites. Después de desayunar proteína:'],
        bullets: [
          '1 taza de café está bien',
          '2 tazas está dentro de lo normal',
          '3 o más tazas pueden volver a disparar el cortisol',
        ],
        after:
          'Si eres sensible a la cafeína, limítate a 1 taza y considera descafeinado después de las 2 PM.',
      },
      {
        q: '¿Qué alimentos debo evitar completamente?',
        paragraphs: ['Durante los 7 días de reset:'],
        bullets: [
          'Aceites de semillas (soya, girasol, cártamo)',
          'Edulcorantes artificiales (aspartamo, sucralosa)',
          'Harinas refinadas (pan blanco, pasta regular)',
          'Azúcares refinados (dulces, refrescos)',
          'Alcohol',
        ],
        after:
          'Después del día 7 puedes reintroducir algunos (especialmente alcohol ocasional), pero mantén los primeros cuatro fuera.',
      },
      {
        q: '¿Puedo comer carbohidratos o tengo que hacer keto?',
        paragraphs: ['Sí, puedes comer carbohidratos. No es una dieta keto. Están permitidos:'],
        bullets: [
          'Avena',
          'Arroz integral',
          'Camote o batata',
          'Frutas (especialmente berries)',
          'Legumbres (lentejas, garbanzos)',
        ],
        after:
          'La clave es combinarlos con proteína y grasas para mantener la glucosa estable. Un carbohidrato solo dispara cortisol.',
      },
      {
        q: '¿Funciona si tengo un trabajo muy estresante?',
        paragraphs: [
          'Sí, y especialmente en ese caso: el protocolo está diseñado para mujeres con estrés crónico laboral. Necesitarás ser más consistente con:',
        ],
        bullets: [
          'La respiración vagal durante el día',
          'El vaciado mental antes de dormir',
          'Las caminatas después de comer',
        ],
        after: 'No elimina el estrés, pero lo hace procesable por tu cuerpo.',
      },
      {
        q: '¿Cuándo empiezo a ver resultados?',
        paragraphs: ['Varía según cada persona, pero típicamente:'],
        bullets: [
          'Días 1-2: mayor claridad mental, mejor sueño',
          'Días 3-5: bajada de inflamación facial y drenaje de agua',
          'Días 6-7: abdomen más suave, energía más estable',
          'Semanas 2-4: desaparición de la hinchazón crónica',
        ],
      },
      {
        q: '¿Qué pasa después de los 7 días? ¿Sigue el efecto?',
        paragraphs: ['Sí, con una condición: mantener las bases. El Capítulo 7 enseña las 3 reglas no-negociables:'],
        bullets: ['Luz solar diaria', 'Proteína en el desayuno', 'Sueño profundo (vaciado mental)'],
        after:
          'Si las respetas, los resultados permanecen. Si vuelves a cardio intenso + estrés + café en ayunas, el cortisol subirá de nuevo.',
      },
      {
        q: '¿Necesito repetir el protocolo cada 7 días?',
        paragraphs: [
          'No. Una vez que completas los 7 días es un reset único; después sigue el mantenimiento del Capítulo 7. Solo vuelves al protocolo completo si pasaste por un periodo de mucho estrés, recaíste en malos hábitos o sientes que la inflamación regresa.',
          'La mayoría lo repite cada 3-6 meses como mini-reset.',
        ],
      },
      {
        q: '¿Puedo combinarlo con otras dietas o protocolos?',
        paragraphs: ['Depende. Es compatible con ayuno intermitente ligero (16/8), dieta mediterránea y alimentación basada en plantas.'],
        bullets: [
          'No recomendado junto a: ayuno prolongado si tienes estrés',
          'No recomendado junto a: dietas muy restrictivas',
          'No recomendado junto a: entrenamiento intenso de competencia',
        ],
        after:
          'Es más un estilo de vida anti-cortisol que una dieta restrictiva; funciona mejor cuando es el protagonista.',
      },
      {
        q: '¿Qué pasa si tengo un día en que lo hago “mal”?',
        paragraphs: [
          'No pasa nada, simplemente continúa. Si un día no ves luz solar, tomas café en ayunas y comes harinas refinadas, no arruinaste todo: tu cuerpo no es tan frágil.',
          'Lo importante es la consistencia general de los 7 días, no la perfección. Muchas mujeres tienen 1-2 días rotos y aun así ven resultados.',
        ],
      },
      {
        q: '¿Puedo hacer el protocolo si viajo?',
        paragraphs: ['Sí, con ajustes. Lo esencial mientras viajas:'],
        bullets: [
          'Ver luz solar (cualquier lugar tiene sol)',
          'Comer proteína en el desayuno (está en cualquier restaurante)',
          'Caminata después de comer (puedes hacerla en la ciudad)',
          'Dormir bien, llevando tu ritual de vaciado mental',
        ],
        after: 'Lo difícil será conseguir sal celta, pero con lo básico funciona.',
      },
      {
        q: '¿Interfiere con medicamentos?',
        paragraphs: [
          'El protocolo en sí no interfiere porque no son medicamentos. Pero si tomas medicación hormonal (anticonceptivos, THS), consulta a tu médico antes: bajar el cortisol podría cambiar cómo responde tu cuerpo.',
          'Si tomas antidepresivos, coordina con tu psiquiatra.',
        ],
      },
      {
        q: '¿Qué pasa con mi período? ¿Afecta el protocolo?',
        paragraphs: [
          'No negativamente. De hecho, muchas mujeres reportan ciclos más regulares. El cortisol alto interrumpe el ciclo menstrual; cuando baja suelen aparecer:',
        ],
        bullets: ['Períodos más regulares', 'Menos síntomas premenstruales', 'Menos calambres'],
      },
      {
        q: '¿Puedo hacerlo si tengo resistencia a la insulina o prediabetes?',
        paragraphs: [
          'Sí, y es especialmente recomendable: la resistencia a la insulina y el cortisol alto están conectados. La técnica de los 20 minutos (caminar después de comer) está pensada justo para estabilizar glucosa.',
          'Consulta igualmente a tu médico o nutricionista, porque pueden recomendarte modificaciones para tu caso.',
        ],
      },
      {
        q: '¿Cuál es la dosis de magnesio glicinato recomendada?',
        paragraphs: ['300 mg, una hora antes de dormir. No necesitas más. Opciones:'],
        bullets: [
          'Magnesio treonato (mejor para cerebro)',
          'Magnesio glicinato (mejor para sueño)',
          'Magnesio taurinato (buen balance)',
        ],
        after: 'Evita el magnesio óxido: tiene efecto laxante y no es lo que buscas.',
      },
      {
        q: '¿Necesito trabajar con un nutricionista?',
        paragraphs: [
          'No, pero puedes si quieres. El protocolo está diseñado para hacerlo sola, con cada paso explicado en el PDF.',
          'Si tienes condiciones médicas complejas, alergias alimentarias o medicación específica, un profesional puede personalizarlo. Es opcional, no requerido.',
        ],
      },
      {
        q: '¿Por cuánto tiempo debo aplicar el protocolo?',
        paragraphs: ['Mínimo 7 días (es el reset). Después tienes dos opciones:'],
        bullets: [
          'Continuar indefinidamente con los hábitos del Capítulo 7',
          'Repetir los 7 días completos cada 3-6 meses como mini-reset',
        ],
      },
      {
        q: '¿Hay algún efecto secundario?',
        paragraphs: ['Es raro, pero algunas mujeres reportan:'],
        bullets: [
          'Primeros 2 días: dolores de cabeza leves (desintoxicación de cafeína)',
          'Primeros 3 días: cambios en la evacuación intestinal (la digestión se reactiva)',
          'Días 1-2: sensación extraña al quitar el café en ayunas',
        ],
        after:
          'Nada de esto es peligroso y desaparece después del día 3. Si tienes efectos más severos, detente y consulta a tu médico.',
      },
      {
        q: '¿Esto está basado en investigación real?',
        paragraphs: ['Sí. Los principios están validados por:'],
        bullets: [
          'Cronobiología (estudio del ritmo circadiano)',
          'Neuroendocrinología (cortisol y sistema nervioso)',
          'Nutrición clínica (efecto de los nutrientes en las hormonas)',
        ],
        after:
          'La Tríada de Poder, el Protocolo 20-20 y la Respiración Vagal tienen estudios detrás. No es magia, es biología aplicada.',
      },
      {
        q: '¿Si no veo resultados en 7 días, qué hago?',
        paragraphs: ['Primero, respira: la mayoría ve cambios en 7 días, pero algunos tardan 14-21. Segundo, revisa si cumpliste:'],
        bullets: [
          '¿Luz solar todos los días?',
          '¿Proteína en el desayuno?',
          '¿Caminata después de comer?',
          '¿Vaciado mental antes de dormir?',
        ],
        after:
          'Si hiciste todo correctamente y aún no ves cambios, usa la garantía de 60 días. Tienes tiempo completo para comprobarlo.',
      },
      {
        q: '¿Puedo comprarlo como regalo para alguien más?',
        paragraphs: ['Sí. Tienes dos opciones:'],
        bullets: [
          'Comprar y regalar el enlace de descarga',
          'Regalar los $15.90 para que ella lo compre directamente',
        ],
        after: 'En ambos casos recibe el acceso completo y la garantía de 60 días es para ella.',
      },
      {
        q: '¿Hay una versión en video del protocolo?',
        paragraphs: [
          'No. Es un PDF descargable, escrito de forma muy clara, con listas y pasos numerados. Si necesitas aclaraciones, escribe a nutrinaturalonline@gmail.com.',
        ],
      },
      {
        q: '¿Puedo imprimirlo?',
        paragraphs: [
          'Sí, es un PDF que puedes imprimir completo. Muchas mujeres lo leen impreso como un libro; otras lo leen en tablet. La flexibilidad es tuya.',
        ],
      },
    ],
  },
  {
    id: 'credibilidad',
    title: 'Sobre la credibilidad',
    items: [
      {
        q: '¿Quién escribió esto? ¿Eres nutricionista?',
        paragraphs: [
          'Está escrito por una especialista en cronobiología nutricional con más de 10 años de investigación en cortisol y desinflamación. No somos médicos (y no lo reclamamos), pero estamos obsesionadas con la ciencia de cómo el cuerpo procesa el estrés.',
        ],
      },
      {
        q: '¿Los testimonios son reales?',
        paragraphs: ['Los testimonios son verificados. Cada persona que ves:'],
        bullets: ['Compró el producto', 'Completó el protocolo', 'Dejó su comentario'],
        after:
          'Hotmart verifica las compras automáticamente. Los resultados, eso sí, varían según cada persona.',
      },
      {
        q: '¿Por qué el precio es tan bajo?',
        paragraphs: [
          'Porque queremos que el dinero no sea la barrera. Un protocolo que funciona pero cuesta $300 solo ayuda a quien ya puede pagarlo; a $15.90 pueden acceder miles de mujeres.',
          'Además es una forma de demostrar que confiamos en la calidad: si fuera malo, la garantía nos arruinaría.',
        ],
      },
    ],
  },
]
